import React from "react";
import { Checkbox, CheckboxField } from "../../../design/checkbox";
import { Label } from "../../../design/fieldset";
import { Textarea } from "../../../design/textarea";
import { ParentingPlanSection } from "../../../models/ParentingPlanSection";
import { ParentingPlanSectionUpdate } from "../types";

interface ParentingPlanSectionComponentProps {
  section: ParentingPlanSection;
  onSectionUpdate: (update: ParentingPlanSectionUpdate) => void;
}

export const ParentingPlanSectionComponent: React.FC<
  ParentingPlanSectionComponentProps
> = ({ section, onSectionUpdate }) => {
  // Determine parent checkbox state dynamically (no need for useState)
  const areAllSubsectionsChecked =
    section.sections &&
    section.sections.length > 0 &&
    section.sections.every((sub) => sub.isChecked);

  const handleParentCheckboxChange = (checked: boolean) => {
    const allSectionIds = [
      section._id,
      ...(section.sections?.map((sub) => sub._id) || []),
    ];

    onSectionUpdate({
      sectionIds: allSectionIds,
      changes: { isChecked: checked },
    });
  };

  return (
    <div className="space-y-4">
      {section.sections && section.sections.length > 0 ? (
        <>
          <CheckboxField>
            <Label>Select all subcategories</Label>
            <Checkbox
              checked={areAllSubsectionsChecked}
              onChange={handleParentCheckboxChange}
            />
          </CheckboxField>
          {section.sections.map((sub) => (
            <div key={sub._id} className="p-4 bg-white border rounded">
              <CheckboxField>
                <Label>{sub.title}</Label>
                <Checkbox
                  checked={sub.isChecked}
                  onChange={(checked) =>
                    onSectionUpdate({
                      sectionIds: [sub._id],
                      changes: { isChecked: checked },
                    })
                  }
                />
              </CheckboxField>
              <Textarea
                defaultValue={sub.body || ""}
                onChange={(e) =>
                  onSectionUpdate({
                    sectionIds: [sub._id],
                    changes: { body: e.target.value },
                  })
                }
                rows={4}
              />
            </div>
          ))}
        </>
      ) : (
        <div className="p-4 bg-white border rounded">
          <CheckboxField>
            <Label>{section.title}</Label>
            <Checkbox
              checked={section.isChecked}
              onChange={(checked) =>
                onSectionUpdate({
                  sectionIds: [section._id],
                  changes: { isChecked: checked },
                })
              }
            />
          </CheckboxField>
          <Textarea
            defaultValue={section.body || ""}
            onChange={(e) =>
              onSectionUpdate({
                sectionIds: [section._id],
                changes: { body: e.target.value },
              })
            }
            rows={4}
          />
        </div>
      )}
    </div>
  );
};
